import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import Icon from './icon';

type Props = {
  label: string,
  className?: string,
};

/* eslint-disable react/no-array-index-key */
export default function Select({ label, className, children }: Props) {
  // Local state
  const [hidden, setHidden] = useState(true);

  // Hide
  const handleHide = useCallback(() => {
    setHidden(true);
    document.removeEventListener('click', handleHide);
  }, []);

  // Show
  const handleShow = useCallback(event => {
    event.stopPropagation();
    setHidden(false);
    document.addEventListener('click', handleHide);
  }, [handleHide]);

  // Remove listener on umount
  useEffect(() => () => document.removeEventListener('click', handleHide), [handleHide]);

  // Render element
  return (
    <div className={classNames('dropdown', className)}>
      <button type="button" onClick={handleShow} className="py-3 px-4 text-base text-gray-600 leading-tight bg-white rounded border border-gray-200 hover:shadow-lg hover:border-gray-300">
        {label}
        <Icon name="chevron-down" className="ml-1" />
      </button>
      {!hidden && (
        <div className="dropdown-content">
          <ul role="menu" className="dropdown-list">
            {children.map((item, i) => <li key={`dropdown-${i}`} className="dropdown-item">{item}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
